<template>
  <v-row>
    <v-dialog v-model="finalizePopupShow" persistent max-width="400">
      <v-card>
        <v-card-title center class="headline text-center">
          <v-flex class="my-2">Finalize purchase?</v-flex>
        </v-card-title>

        <v-card-text class="black--text py-3 text-center">
          <p
            class="font-weight-medium body-1"
          >By clicking "Finish" button purchase will be finalized and invoice will be sent to entered email.</p>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-flex justify="center">
            <v-btn class="my-3 mx-3" color="success" width="100" @click="cancelButtonActions">Cancel</v-btn>
            <v-btn
              class="my-3 mx-3"
              color="success"
              width="100"
              :disabled="!finishButtonShow"
              @click="finishButtonActions"
            >Finish</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import ReCaptcha from "@/components/ReCaptcha";
export default {
  components: {
    ReCaptcha
  },
  data() {
    return {
      finishButtonShow: true,
      finalizePopupShow: true
    };
  },
  methods: {
    closePopup() {
      this.$emit("change", {
        finalizePopupShow: false
      });
    },
    cancelButtonActions() {
      this.$gtm.trackEvent({
        category: "finalize-popup-cancel-button",
        action: "click",
        noninteraction: false
      });
      this.closePopup();
    },
    finishButtonActions() {
      this.$gtm.trackEvent({
        category: "finalize-popup-finish-button",
        action: "click",
        noninteraction: false
      });
      this.makeSubmit();
      this.closePopup();
    },
    makeSubmit() {
      this.$emit("change", {
        makeSubmit: true
      });
    }
  }
};
</script>

<style>
</style>